import { Resource as s, API as a } from "@coveo/platform-client";
const t = class t extends s {
  /**
   * Retrieves all license products for the specified organization, grouped by productKey.
   */
  products() {
    return this.api.get(t.baseUrl);
  }
};
t.baseUrl = `/api/private/organizations/${a.orgPlaceholder}/license/products`;
let r = t;
export {
  r as PrivateLicenseResource
};
//# sourceMappingURL=PrivateLicenseResource.js.map
